<script setup lang="ts">
import SearchResult from '~/components/header/general-search/SearchResult.vue'
import SearchBar from '~/components/search/SearchBar.vue'
import { useGeneralSearch } from '~/composables/useGeneralSearch'
import { useMedia } from '~/composables/useMedia'

const isResultShow = ref(false)

const setResultShow = (value: boolean) => {
  isResultShow.value = value
}

const inputModel = ref<string>('')

const { resultMap, isFetching, moveToOnlyResult } = useGeneralSearch(inputModel)

const { isMobile } = useMedia()

watchEffect(() => {
  if (isMobile.value) {
    inputModel.value = ''
  }
})
</script>

<template>
  <div class="general-search-bar flex items-center">
    <SearchBar
      @set-result-show="setResultShow"
      @enter="moveToOnlyResult"
      placeholder="Search by Address, TX ID, Block"
      v-model="inputModel"
    />
    <SearchResult
      v-show="isResultShow"
      class="result"
      :input-value="inputModel"
      :result-map="resultMap"
      :is-fetching="isFetching"
    />
  </div>
</template>

<style scoped lang="scss">
.general-search-bar {
  @apply bg-default/5 border border-default/10 relative focus-within:border-primary h-9 hover:bg-default/10 transition-all duration-300 ease-[ease];
}

.result {
  @apply absolute left-0 w-full max-h-64 bg-default/10 backdrop-blur-[32px];
  top: calc(100% + 0.5rem);
}
</style>